import { Box, Flex, Image, Input, InputGroup, InputLeftElement, Text, Table, Thead, Tr, Th, Tbody, Td, Button, Tooltip, TableContainer, Center, Spinner, } from '@chakra-ui/react';
import { Search2Icon, DeleteIcon } from '@chakra-ui/icons';
import MyDiv from './roles.style';
import { ActionEditIcon, AlertCard, CustomButton, CustomToast } from '../../../../components';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useNavigate } from 'react-router-dom';
import * as routesNames from '../../../../constants/routes'
import { useEffect, useState } from 'react';
import { head, IData, IRole } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import CustomTable, { Column } from '../../../../components/CustomTable/customTable';

const Roles = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<IData>({ roles: [], count: 0 });
  const [roleToDelete, setRoleToDelete] = useState<number | null>(null);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  const loadRoles = async () => {
    const pages = await fetchApi<IData>('role', 'GET');
    if (pages) setData(pages);
  }

  useEffect(() => {
    loadRoles();
  }, []);

  const handleClick = () => {
    navigate(routesNames.NEWROLE)
  };

  const handleDelete = (id: number) => {
    setRoleToDelete(id);
    setDeleteAlert(true);
  };

  const confirmDelete = async () => {
    if (!roleToDelete) return;
    const res = await fetchApi(`role/${roleToDelete}`, "DELETE", null, null, "");
    if (res ) {
     addToast({ message: res.message, status: "success" });
    }
    setDeleteAlert(false);
    setRoleToDelete(null);
    loadRoles();
  };

  const handleEdit = (role: IRole) => {
    navigate(routesNames.NEWROLE, {
      state: { role: role, isEditing: true }
    });
  };

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header" >
          <Text className="font-poppins text_semibold text_3xl">Roles List </Text>
          <Flex gap={2}>
            <CustomButton title="Add New Role" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleClick} />
          </Flex>
        </Flex>

        <Box mt={4} overflowX="auto" borderRadius="md" boxShadow="sm" bg="#fff">
          <Box position="relative" minH="300px">
            {loading ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
              </Center>) : (
              <>
                <CustomTable value={data.roles}>
                  <Column header="S. No" body={(_, index) => index + 1} />
                  <Column
                    header="Role Name"
                    body={(role: any) => (
                      <Text className="font-poppins text_regular text_sm" maxW="9vw" isTruncated >{role.name}</Text>
                    )}
                  />
                  <Column
                    header="Role Description"
                    body={(role: any) => (
                      <Tooltip label={role.description} aria-label="Full description" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow >
                        <Box as="span" display="inline-block" w="100%" isTruncated>
                          <Text className="font-poppins text_regular text_sm" maxW="9vw" isTruncated >
                            {role.description}
                          </Text>
                        </Box>
                      </Tooltip>
                    )}
                  />
                  <Column
                    header="Edit Permission"
                    body={(role: any) => (<ActionEditIcon onClick={() => handleEdit(role)} />
                    )}
                  />
                  <Column
                    header="Action"
                    body={(role: any) => (
                      <Flex justify="center">
                        <Button size="sm" className="del font-poppins text_regular text_sm" leftIcon={<DeleteIcon />} onClick={() => handleDelete(role.id)} >
                          Delete
                        </Button>
                      </Flex>
                    )}
                  />
                </CustomTable>

              </>)}
          </Box>
        </Box>
      </Box>

      <AlertCard
        isOpen={deleteAlert}
        onClose={() => {
          setRoleToDelete(null);
          setDeleteAlert(false);
        }}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this role?"
        confirmLabel="Delete"
        cancelLabel="Cancel"
        colorScheme="red"
      />
    </MyDiv>
  );
};

export default Roles;
